import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';

import type { TagDemographic, TagFilter } from './types';

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: retry(axiosBaseQuery(), { maxRetries: 0 }),
  endpoints: (builder) => ({
    getDemographics: builder.query<TagDemographic[], { reportId: number; filters?: TagFilter[] }>({
      query: ({ reportId, filters }) => ({
        url: '/tags/demographics',
        method: 'POST',
        data: { reportId, filters: filters ?? [] },
      }),
    }),
  }),
});

export const { useGetDemographicsQuery } = tagsApi;
